import Vue from 'vue'
export default new Vue()

// 信息传递专用